import { Box, Heading, Text } from "@radix-ui/themes";
import {
	Locale,
	useLocalization,
} from "~/components/localization/LocalizationProvider";
import styles from "../live-seo-page.module.css";

type TermsConditionsLocalization = {
	title: string;
	companyLabel: string;
	company: string;
	programLabel: string;
	program: string;
	frequencyLabel: string;
	frequency: string;
	pricingLabel: string;
	pricing: string;
	stopLabel: string;
	stopPrefix: string;
	stopLink: string;
	carrierLabel: string;
	carrier: string;
};

const termsConditionsLocalization = {
	[Locale.EN]: {
		title: "Terms & Conditions",
		companyLabel: "Company:",
		company: "Miami Orthodontic Specialists",
		programLabel: "Program Description:",
		program: "Appointment Reminders, patient communication.",
		frequencyLabel: "Message Frequency:",
		frequency: "Message frequency varies",
		pricingLabel: "Pricing Disclosure:",
		pricing: "Message and data rates may apply.",
		stopLabel: "Stop & Help Keywords:",
		stopPrefix: "Reply STOP to cancel or call our office at ",
		stopLink: "305.407.9000",
		carrierLabel: "Carrier Disclaimer:",
		carrier: "Carriers are not liable for delayed or undelivered messages",
	},
	[Locale.ES]: {
		title: "Términos y condiciones",
		companyLabel: "Empresa:",
		company: "Miami Orthodontic Specialists",
		programLabel: "Descripción del programa:",
		program: "Recordatorios de citas y comunicación con pacientes.",
		frequencyLabel: "Frecuencia de mensajes:",
		frequency: "La frecuencia de los mensajes varía",
		pricingLabel: "Divulgación de precios:",
		pricing: "Pueden aplicar tarifas de mensajes y datos.",
		stopLabel: "Palabras clave para detener y ayuda:",
		stopPrefix: "Responde STOP para cancelar o llama a nuestra oficina al ",
		stopLink: "305.407.9000",
		carrierLabel: "Descargo de responsabilidad del operador:",
		carrier:
			"Los operadores no son responsables por mensajes retrasados o no entregados",
	},
} satisfies Record<Locale, TermsConditionsLocalization>;

export function TermsConditionsPage() {
	const getLocalization = useLocalization(termsConditionsLocalization);

	return (
		<Box className={styles.simplePageBand}>
			<Box className={styles.simplePageInner}>
				<Heading as="h1" className={styles.simplePageTitle}>
					{getLocalization("title")}
				</Heading>
				<Box className={styles.termsCopy}>
					<Text as="p" size="4">
						<strong>{getLocalization("companyLabel")}</strong>{" "}
						{getLocalization("company")}
					</Text>
					<Text as="p" size="4">
						<strong>{getLocalization("programLabel")}</strong>{" "}
						{getLocalization("program")}
					</Text>
					<Text as="p" size="4">
						<strong>{getLocalization("frequencyLabel")}</strong>{" "}
						{getLocalization("frequency")}
					</Text>
					<Text as="p" size="4">
						<strong>{getLocalization("pricingLabel")}</strong>{" "}
						{getLocalization("pricing")}
					</Text>
					<Text as="p" size="4">
						<strong>{getLocalization("stopLabel")}</strong>{" "}
						{getLocalization("stopPrefix")}
						<a href="tel:3054079000">{getLocalization("stopLink")}</a>
					</Text>
					<Text as="p" size="4">
						<strong>{getLocalization("carrierLabel")}</strong>{" "}
						{getLocalization("carrier")}
					</Text>
				</Box>
			</Box>
		</Box>
	);
}
